import BodyParts from "../../components/LKG/GeneralAwareness/BodyParts";
import GoodHabbits from "../../components/LKG/GeneralAwareness/GoodHabbits";
import PeopleHelpUs from "../../components/LKG/GeneralAwareness/PeopleHelpUs";
import Seasons from "../../components/LKG/GeneralAwareness/Seasons";
import Transports from "../../components/LKG/GeneralAwareness/Transports";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - LKG - General Awareness";

const topics: MenuItem[] = [
    { url: "/lkg/general-awareness/body-parts", title: "Body Parts", component: BodyParts },
    { url: "/lkg/general-awareness/people-who-help-us", title: "People Who Helps Us", component: PeopleHelpUs },
    { url: "/lkg/general-awareness/seasons", title: "Seasons", component: Seasons },
    { url: "/lkg/general-awareness/transports", title: "Transports", component: Transports },
    { url: "/lkg/general-awareness/good-habits", title: "Good Habits & Manners", component: GoodHabbits },
];

export default topics;